"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * fires a scrollEvent while track is moving so components that integrate lazyLoading on their own (via scroll event listener) can load their content
 */
var fakeScroll = function (jestTest) {
    if (window.dispatchEvent && !jestTest) {
        window.dispatchEvent(new CustomEvent('scroll'));
    }
    else {
        window.scrollTo(window.scrollX, window.scrollY - 1);
        window.scrollTo(window.scrollX, window.scrollY + 1);
    }
};
exports.default = fakeScroll;
//# sourceMappingURL=fakeScroll.js.map